module.exports = __webpack_public_path__ + "static/ngpm-cut-b60cb5f92d414a9db2fe07227185c9d4.jpg";